import { CustomField } from '@/models/customField';
import apiClient from '@/api/client';

export const PartnerCustomFieldService = {
    async getAll(): Promise<PartnerCustomFieldResponse> {
        const response = await apiClient.get<PartnerCustomFieldResponse>('/partner/custom-fields');
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to retrieve custom fields.');
        }

        return result;
    },

    async update(id: string, name?: string, description?: string) {
        const response = await apiClient.put(`/partner/custom-fields/${id}`, {
            name: name,
            description: description, 
        });

        if (response.status != 200) {
            throw new Error('Failed to update custom field.');
        }
    },

    async create(name: string, parentCustomFieldId?: string, description?: string) {
        const response = await apiClient.post('/partner/custom-fields', { 
            name: name,
            parentCustomFieldId: parentCustomFieldId, 
            description: description
        });

        if (response.status != 201) {
            throw new Error('Failed to create custom field.');
        }
    },

    async delete(id: string) {
        const response = await apiClient.delete(`/partner/custom-fields/${id}`);
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to delete custom field.');
        }

        return result;
    },
}

export interface PartnerCustomFieldResponse {
    customFields: CustomField[]
}